<template>
    <div>
            <top-navbar></top-navbar>


            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Employee </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/questions/index"> Feedback  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{all_data.code }} </h6>
                <!-- <img :src="imageUrl" alt="Your Image">
                <img src="../../../public/img/evenware-logo.png" width="140px" alt="Evenware Logo"> -->
            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->




               
                <b-modal :id="infoModal1.id"
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"

     bottom>
    <template   #modal-title>

      <h3 >Confirm !</h3>



    </template>

    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm ?</h5>
    </div>
    <hr>

    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>


  </b-modal>


            <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                <div >




                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">

                        <tbody >


                          <tr>
                            <td class="width-custom2"><b>Questionnaire Code </b></td>
                           <td>{{ all_data.code }}</td>
                          </tr>
                          <tr>
                            <td><b>Questionnaire Name</b></td>
                           <td>{{ all_data.questionnaire_name }}</td>
                          </tr>
                           <tr>
                            <td><b>Show Type</b></td>
                           <td>{{ all_data.userchech }}</td>
                          </tr>


                          
                         
                         

                        


                        </tbody>


                      </table>

                      
 <div v-if="all_data.userchech=='Anonymous'" class="row" >
 
  <div  class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Anonymous </label>
         <input v-model="all_data.userchech"   style="font-size: small;" class="form-control bdr-rad" disabled>
    </div> 
  </div>

 </div>

 <div v-else class="row" >
  <div  class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Enter  Name </label>
         <input v-model="alldata.name"   style="font-size: small;" class="form-control bdr-rad" >
    </div> 
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Enter Email </label>
            <input v-model="alldata.email"  style="font-size: small;" class="form-control bdr-rad" >
    </div> 
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Enter Contact No </label>
            <input  v-model="alldata.phone" style="font-size: small;" class="form-control bdr-rad" >
    </div> 
  </div>



</div>

                      </div>
                      </div>



                      <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Questionnaire</b></h6>

   <div class="table-responsive">
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Category</th>
                              <th >Question</th>
                              <th >Remarks</th>
                              <th >Select Choices</th>
                              
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(detail, index) in details" :key="detail.id">
                              <td>{{ index+1 }}</td>
                              <td>{{detail.Category}}</td>
                              <td >{{detail.Question}}</td>
                              <td >{{detail.remark}}</td>
                              <td v-if="detail.multichoice=='multiple_choice'"> <div v-for="(c, index) in detail.choises" :key="index" class="form-check">
  <input
    class="form-check-input"
    type="radio"
    :id="'choice_' + detail.id + '_'+index "
    :name="'choice_'+ detail.id"
    :value="c.value"
    v-model="detail.selectedChoice"
  />
  <label class="form-check-label" :for="'choice_' + detail.id + '_'+index ">
    {{ c.label }}
  </label>
</div>

                                </td>
                                <td v-else>  <input v-model="detail.result"  style="font-size: small;" class="form-control bdr-rad" ></td>
                             
                             </tr>
                             
                             
                            </tbody>

                          </table>
                        </div>

<div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="" @click="submitSheet" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Submit</button>
    </div>
    </div>
    </div>
</div>

 







<br><br>










                </div>
                </div>
              </div>
            </div>

            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
   import jsPDF from 'jspdf';
   import 'jspdf-autotable';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'



      export default {

        mounted(){
    this.loadAlldata()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            username:authService.isUsername(),
            'id':this.$route.query.id,
            total:{},
            all_data:{},
            alldata:{},
            category:{},
            isLoading:true,
            brand:{},
            supplier:{},
            status:{},
            user:{},
            all_code:{},
            crm:{},
            // isLoading:true,
            details:[],
            mservicelogs:[],
            trans:[],
            width:5,
            height:5,
            infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },

     
          }

        },
        components :{

            ContentFooter,
            TopNavbar,

        },

        methods : {


       
          async submitSheet() {


       try {
         const { data} = await  axios.post('/questions/submitresult?id='+this.id,{all_data:this.all_data,alldata:this.alldata,details:this.details},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',

           }
          });
          console.log(data);
          if(data.status==200){
          window.location.reload();

          }

       } catch (error) {
         console.log(error.response);
       }
     },


    


       

    
         

            async loadAlldata() {
        console.log("Amila");
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/questions/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',

          }
         });
         console.log(data);
         this.all_data = data.all_data;
        
         this.details = data.details;

          this.isLoading = false;
      

      } catch (error) {
        console.log(error.response);
      }
    },







    },

    }

    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;



  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>
